<template>
  <div>
    <div class="banner"  :style="{
              backgroundImage: `url(${require(`@/assets/${detail.img}`)})`
            }">
      <div class="titleSub">{{detail.englishTitle}}</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">
        {{ detail.title }}
      </div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">
      {{detail.desc}}
      </div>
    </div>
    <div class="difficult">
      <div style="text-align: center">
        <div class="titleSub">{{detail.difficult.difficultSecondTitle}}</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">
          {{detail.difficult.difficultTitle}}
        </div>
        <div class="difficult-con" style="display: flex;align-items: start">
          <img class="wow animate__animated durationTime animate__fadeInUp" :src="require(`@/assets/${detail.difficult.difficultImageSrc}`)" >
          <div class="difficult-con-list">
            <div class="con wow animate__animated durationTime animate__fadeInUp"  style="" v-for="(item,index) in detail.difficult.difficult">
              <div class="icon" style=""></div>
              <div class="text">
                <div class="title1" style="">{{item.title}}</div>
                <div class="desc1">{{item.desc}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="value">
      <div style="text-align: center">
        <div class="titleSub">{{detail.solutionSecondTitle}}</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">
          {{detail.solutionTitle}}
        </div>
        <div class="word wow animate__animated durationTime animate__fadeInUp">  {{detail.solutionSecondDesc}}</div>
      </div>
      <div class="box">
        <div class="menu">
          <div @click="changeTab(item)" :class="['tab',activeTab==item?'activeTab':'' ]" v-for="(item,index) in detailTitle" :key="item" class="tab">{{item}}</div>
        </div>
        <img class="wow animate__animated durationTime animate__fadeInUp" :src="require(`@/assets/${activeCon.img}`)" >
        <div class="introduce">
          <div class="title wow animate__animated durationTime animate__fadeInUp">{{activeCon.title}}</div>
          <div class="desc wow animate__animated durationTime animate__fadeInUp">{{activeCon.desc}}</div>
        </div>
      </div>
    </div>
    <div class="product">
      <div style="text-align: center">
        <div class="titleSub">Related products</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">
          相关产品
        </div>
      </div>
      <div class="product-list">
        <div class="box">
          <div class="product-item item-le-product">
            <div
              class="item  wow animate__animated durationTime animate__fadeInUp"
              v-for="(item, index) in products"
              :key="`product-item` + index"
              @click="handleDetail(item.id)"
            >
              <img
                style="width: 1.67rem"
                :src="require(`@/assets/${item.imageSrc}`)"
              />
              <div class="introduce">
                <div class="t">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { WOW } from "wowjs";
import detailData from "../solution/detailData";
import productData from "../product/productsData";
export default {
  name: "index",
  data() {
    return {
      detail: [],
      imageSrc:'image/solution/solution-wx-zz.png',
      detailTitle:[],
      activeTab:'',
      activeCon:{},
      products:[],
    };
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.handData(newVal);

    }
  },
  created() {
    let id = this.$route.query.id === undefined ? "0" : this.$route.query.id;
    this.handData(8);

  },
  methods:{
    handleDetail(id) {
      let routeName='productDetail'
      this.$router.push({
        name: routeName,
        query: {
          id: id
        }
      });
    },
    handData(index){
      this.detail = detailData[index];
      for(let i=0;i<this.detail.detail.length;i++){
        this.detailTitle.push(this.detail.detail[i].title)
      }
      this.activeTab=this.detail.detail[0].title
      this.changeTab(this.activeTab);
      for (let i=0;i<productData.length;i++){
        if(this.detail.products.includes(productData[i].id)){
          this.products.push(productData[i]);
        }
      }
    },
    changeTab(title){
      for(let i=0;i<this.detail.detail.length;i++){
        if(this.detail.detail[i].title==title){
          this.activeCon=this.detail.detail[i];
        }
      }
      this.activeTab=title;
    }
  },
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  }
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  //background: url("../../assets/image/solution/detail.png") center
  //  no-repeat;
  background-size: cover;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.25rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "";
    position: absolute;
    margin-top: 1.94rem;
    margin-left: 2.18rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .desc {
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
    margin-top: 0.2rem;
    margin-left: 2.18rem;
    width: 10.01rem;
    line-height: 0.4rem;
  }
}
.difficult{
  padding:1rem 2.18rem;
  .title {
    font-size: 0.32rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color:  #333333;
    margin-top: -0.25rem;
    margin-bottom: 0.8rem;


  }

  .titleSub {
    content: "";
    font-size: 0.34rem;
    font-weight: 500;
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0,0,0,.16);
    letter-spacing: .02rem;
  }
  .difficult-con{
    img{
      width: 7.2526rem;
      height: 3.8715rem;
      margin-right: 0.66rem;
    }
    .difficult-con-list{
      .con{
        display: flex;
        margin-bottom: 0.4rem;
        position: relative; /* 相对定位 */
        padding-left: 0.2rem; /* 圆点的宽度加上间距 */
        .icon{
          position: absolute; /* 绝对定位 */
          left: 0; /* 相对于 .list-item 左侧对齐 */
          //transform: translateY(-50%); /* 垂直居中 */
          width: 0.1rem; /* 圆点的直径 */
          height: 0.1rem;
          background-color: #FEF100; /* 圆点的颜色 */
          border-radius: 50%; /* 将正方形变成圆形 */
          margin-right: 0.1rem; /* 圆点和文字之间的间距 */
          margin-top: 0.1rem;

        }
        .text{
          .title1{
            margin-bottom: 0.2rem;
            font-size:.24rem;
            color: #333333;
            font-weight: 500;
            text-align: start;
          }
          .desc1{
            text-align: start;
            font-size: 0.18rem;
          }
        }
      }
    }
  }
}
.value{
  padding:1rem 2.18rem;
  background: url("../../assets/image/solution/value-bg.png") center
  no-repeat;
  background-size: cover;
  .title {
    font-size: 0.24rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color:  #333333;
    margin-top: -0.25rem;
    margin-bottom: 0.2rem;


  }

  .titleSub {
    content: "";
    font-size: 0.34rem;
    font-weight: 500;
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0,0,0,.16);
    letter-spacing: .02rem;
  }
  .word{
    font-weight: 400;
    font-size: 0.18rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  .box{
    padding: 1.05rem 1rem;
    background: #FAFAFA;
    display: flex;
    align-items: center;
    .menu{
      width: 3rem;
      border-right: 0.01rem solid #f4f4f4;
      .tab{
        padding: 0.16rem 0 0.16rem 0.4rem;
        width: 3rem;
        height: 0.6rem;
        display: flex;
        align-items: center;
        font-size: 0.2rem;
        color: #333333 ;
        font-weight: 400;
        cursor: pointer;
      }
      .activeTab{
        background: url("../../assets/image/solution/detail-list-bg.png") center
        no-repeat;
        color: #3B5377 ;
        font-weight: 500;
      }
    }
    img{
      //width: 2.0069rem;
      height: 2.3485rem;
      margin-left: 0.8rem;
    }
    .introduce{
      margin-left: 0.65rem;
      .text{
        font-weight: 500;
        font-size: 0.24rem;
        color: #333333;
        margin-bottom: 0.2rem;
      }
      .desc{
        font-weight: 400;
        font-size: 0.16rem;
        color: #666666;
        line-height: 0.3rem;
        //width: 7.02rem;
      }
    }
  }
}
.product{
  padding: 1rem 2.18rem 0.8rem 2.18rem;
  .title {
    font-size: 0.32rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color:  #333333;
    margin-top: -0.25rem;
    margin-bottom: 0.2rem;


  }

  .titleSub {
    content: "";
    font-size: 0.34rem;
    font-weight: 500;
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0,0,0,.16);
    letter-spacing: .02rem;
  }
  .product-list {
    flex: 1;
    &::-webkit-scrollbar {
      display: none;
    }

    .box:first-child {
      padding-top: 0;
    }
    .box {
      padding-top: 0.4rem;
      .box-first-title {
        font-weight: 500;
        font-size: 0.26rem;
        color: #333333;
        margin-bottom: 0.4rem;
      }
      .box-second-title {
        margin-top: 0.4rem;
        display: flex;
        align-items: center;
        .desc {
          font-weight: 500;
          font-size: 0.22rem;
          color: #333333;
          margin-right: 0.2rem;
        }
      }
      .box-second-title:first-child {
        margin-top: 0;
      }
      .product-item {
        //padding: 0.2rem 0 0.2rem 0;
        align-items: center;
        flex-wrap: wrap;
        display: flex;
        justify-content: space-between;
        .item {
          &:hover {
            background: url("../../assets/image/product/product-item-bg.png")
            center no-repeat;
            background-size: cover;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            .introduce {
              .desc {
                color: #333333;
              }
            }
            background-color: #f6f6f6;
          }
          cursor: pointer;
          display: flex;
          width: calc((100% - 0.4rem) / 3);
          align-items: center;
          background: #f6f6f6;
          padding: 0.2rem;
          //margin-bottom: 0.2rem;
          transition: all 0.3s ease-in-out;
          .introduce {
            //width: 3.5rem;
            margin-left: 0.44rem;
            .t {
              font-weight: 500;
              font-size: 0.2rem;
              color: #333333;
              margin-bottom: 0.2rem;
            }
            .desc {
              font-weight: 400;
              font-size: 0.16rem;
              color: #666666;
              margin-bottom: 0.2rem;
              text-indent: 2em;
            }
            .more {
              display: flex;
              align-items: center;
              div {
                font-weight: 400;
                font-size: 0.16rem;
                color: #333333;
                margin-right: 0.1rem;
              }
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/school/school.vue